import { Component, OnDestroy, OnInit } from '@angular/core';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { IWebContantArticleDisclosures, IWebContantArticleSocialLinks } from '../../../services/liferay/liferay.interface';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from '../../../services/data/data.service';
import { FOOTER_LINKS, SOCIAL_LINKS_DISABLED_CLIENTS, THIRD_PARTY_VENDORS_LIST } from '../../../utils/constants';
import { IFooterLinks } from '../../../interfaces/IFooter';
import { IContractData } from '../../../interfaces/IJob';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { DO_NOT_SELL_LINK, FOOTER_DISCLOSURES_LINK, FOOTER_LABEL, FOOTER_PRIVACY_POLICY_LINK, FOOTER_TERMS_OF_USE_LINK } from '../../../services/ga4/ga4.constant';
import { RouterService } from '../../../services/router/router.service';
import { trackByIndex } from '../../../utils/helper';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  disclosureContent: string = '';
  isDisclosureVisible: boolean = false;
  socialLinksContentLinks!: IWebContantArticleSocialLinks[];
  cleaner$ = new Subject<void>();
  thirdPartyVendors: string[] = THIRD_PARTY_VENDORS_LIST;
  public footerLinks: IFooterLinks = FOOTER_LINKS;
  private footerBaseUrl = environment.footerBaseUrl;
  public baseUrlPath: string = this.footerBaseUrl.withHeaderLink;
  public isThirdPartyVendor: boolean = false;
  public currYear: number = new Date().getFullYear();
  disclosureLinkLabel: string = FOOTER_DISCLOSURES_LINK;
  privacyPolicyLinkLabel: string = FOOTER_PRIVACY_POLICY_LINK;
  termsLinkLabel: string = FOOTER_TERMS_OF_USE_LINK;
  doNotSellLink:string = DO_NOT_SELL_LINK;
  trackByIndex = trackByIndex;
  contractData: IContractData | null = null;
  constructor(
    private liferayService: LiferayService,
    private sanitizer: DomSanitizer,
    private dataService: DataService,
    private routerService: RouterService,
    private ga4Service: Ga4Service
    
  ) { }

  ngOnInit(): void {
    this.observableSubscription();
    const disclosureContent = LIFERAY_WEB_CONSTANT.disclosure;
    this.liferayService.getWebContent<IWebContantArticleDisclosures>(
        disclosureContent.type, disclosureContent.id
      ).pipe(takeUntil(this.cleaner$)).subscribe(disclosure => {
          this.disclosureContent = disclosure.value['footer-content'] || '';
    })
  }

  observableSubscription(): void {
    combineLatest([
      this.dataService.contractData$,
      this.dataService.siteName$
    ])
      .pipe(takeUntil(this.cleaner$))
      .subscribe(([contractData, siteName]: [IContractData | null, string]) => {
        this.contractData = contractData;
        if (this.contractData) {
          this.getSocialWebContent();
        }

        const isThirdParty = this.thirdPartyVendors.includes(siteName);
        this.baseUrlPath = isThirdParty ? this.footerBaseUrl.withOutHeaderLink : this.baseUrlPath;
        this.isThirdPartyVendor = isThirdParty;
        if (!isThirdParty) {
          this.setFooterLinks();
        }
      });
  }



  /**
   * @description Get Disclosure Web Content
   */
  getSocialWebContent(): void {
    
    const socialLinksContent = LIFERAY_WEB_CONSTANT.social_links_content;

    this.liferayService.getWebContent<IWebContantArticleSocialLinks[]>(
      socialLinksContent.type, socialLinksContent.id
    )
      .pipe(takeUntil(this.cleaner$))
      .subscribe({
        next: (socialLinks) => {
          if (this.contractData && SOCIAL_LINKS_DISABLED_CLIENTS.includes(this.contractData?.baseContract.clientId)) {
            this.socialLinksContentLinks = [];
          } else {
            this.socialLinksContentLinks = socialLinks.value || [];
          }
        },
        error: (err) => {
          console.error('Error fetching web content:', err);
        }
      });
  }

  public setFooterLinks(): void {
    const footerLinks: IFooterLinks = {
      ...FOOTER_LINKS,
      disclosures: {
        name: FOOTER_LINKS.disclosures.name,
        url: this.sanitizer.bypassSecurityTrustUrl(`${this.baseUrlPath}`+`${FOOTER_LINKS.disclosures.url}`),
      },
      privacyPolicy: {
        name: FOOTER_LINKS.privacyPolicy.name,
        url: this.sanitizer.bypassSecurityTrustUrl(`${ this.baseUrlPath }`+`${ FOOTER_LINKS.privacyPolicy.url }`),
      },
      termsOfUse: {
        name: FOOTER_LINKS.termsOfUse.name,
        url: this.sanitizer.bypassSecurityTrustUrl(`${this.baseUrlPath}${FOOTER_LINKS.termsOfUse.url }`),
      },
      doNotSell: {
        name: FOOTER_LINKS.doNotSell.name,
        url: this.sanitizer.bypassSecurityTrustUrl(`${this.footerBaseUrl.doNotSellUrl}`),
      },
    };
    this.footerLinks = footerLinks;
  }

  iconClassesMap: { [key: string]: string } = {
    'Facebook': 'pi pi-facebook',
    'Instagram': 'pi pi-instagram',
    'YouTube': 'pi pi-youtube',
  }

  navigateThirdpartyVendor(path: string): void {
    this.routerService.goto(path);
  }
  
  gaIntegration(buttonName: string): void {
    this.ga4Service.buttonClickEvent(`${buttonName}_link`, FOOTER_LABEL);
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
